// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__yqYw5","notificationsContainer":"skeleton_notificationsContainer__X6LDM"};